import produce from "immer";

const COUNTER_INCREMENT = 'peptalkr/counter/INCREMENT';
const COUNTER_DECREMENT = 'peptalkr/counter/DECREMENT';
const COUNTER_RESET = 'peptalkr/counter/RESET';

export const increment = () => ({ type: COUNTER_INCREMENT });
export const decrement = () => ({ type: COUNTER_DECREMENT });
export const reset = () => ({ type: COUNTER_RESET });

const initialState = {
    count: 0
};

export default produce((draft, action) => {
    switch (action.type) {
        case COUNTER_INCREMENT:
            draft.count = draft.count + 1;
            return;
        case COUNTER_DECREMENT:
            draft.count = draft.count - 1;
            return;
        case COUNTER_RESET:
            draft.count = 0;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/counter.js